import * as yup from "yup";
const PHONE_REGEX =
  /^\+?[1-9]\d{1,14}$/;

export const signUpSchema = yup.object().shape({
    firstName: yup.string().min(1).max(30).required(),
    lastName: yup.string().min(1).max(30).required(),
    email: yup.string().email().required(),
    phoneNumber: yup.string().required(),
    zipCode: yup.string().min(5).max(10).required(),
    password: yup.string().max(30).min(6, "Password must be at least 6 characters").matches( /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^\\w]).*$/,  "Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character").required("Password is required"),
    confirmPassword: yup.string()
      .oneOf([yup.ref("password")], "Passwords must match!")
      .required(),
    speciality: yup.array()
    .of(yup.string().max(100))
    .min(1, "At least one specialty is required") 
    .required("At least one specialty is required"),
});

export const loginSchema = yup.object({
  email: yup.string().email("Invalid email format").required("Email is required"),
  password: yup.string().required("Password is required"),
});

export const emailVerificationSchema = yup.object({
  email: yup.string().email("Invalid email format").required("Email is required"),
})

export const setPasswordSchema = yup.object().shape({
  password: yup.string()
    .min(6, 'Password must be at least 6 characters long')
    .max(30, 'Password cannot exceed 30 characters')
    .matches(
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w]).*$/,
      'Password must include a number, lowercase and uppercase letter, and a special character!'
    )
    .required('Password is required'),
  confirmPassword: yup.string()
    .oneOf([yup.ref('password'), null], 'Passwords must match!')
    .required('Confirm Password is required'),
});

export const createDoctorValidationSchema = yup.object({
  firstName: yup.string().required('First Name is required'),
  lastName: yup.string().required('Last Name is required'),
  email: yup.string().email('Invalid email address').required('Email is required'),
  zipCode: yup.string().required('Zipcode is required'),
  phoneNumber: yup.string().required('Phone Number is required'),
  speciality: yup.array().required('Speciality is required')
});

export const inviteProviderValidationSchema = yup.object({
  organizationName: yup.string()
    .max(100, 'Organization Name should not exceed 100 characters')
    .required('Organization Name is required'),

  // organizationType: yup.string()
  //   .max(100, 'Organization Type should not exceed 100 characters')
  //   .required('Organization Type is required'),

  // phoneNumber: yup.string().required('Phone Number is required'),
  // streetAddress: yup.string()
  //   .max(100, 'Street Address should not exceed 100 characters')
  //   .required('Street Address is required'),

  // city: yup.string().required('City is required'),
  // state: yup.string().required('State is required'),
  // zipCode: yup.string()
  //   .matches(/^\d{5}(-\d{4})?$/, 'ZIP Code must be a valid postal code')
  //   .required('ZIP Code is required'),

  // latitude: yup.string()
  //   .matches(/^-?\d+(\.\d+)?$/, 'Latitude must be a valid number')
  //   .required('Latitude is required'),

  // longitude: yup.string()
  //   .matches(/^-?\d+(\.\d+)?$/, 'Longitude must be a valid number')
  //   .required('Longitude is required'),

  email: yup.string().email('Invalid email address').required('Email is required'),
})

export const signupProviderSchema = yup.object().shape({
  organizationName: yup.string()
  .max(100, 'Organization Name should not exceed 100 characters')
  .required('Organization Name is required'),

  organizationType: yup.string()
  .max(100, 'Organization Type should not exceed 100 characters')
  .required('Organization Type is required'),

  phoneNumber: yup.string().required('Phone Number is required'),
  email: yup.string().email().required(),
  streetAddress: yup.string()
    .max(100, 'Street Address should not exceed 100 characters')
    .required('Street Address is required'),

  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  zipCode: yup.string()
    .matches(/^\d{5}(-\d{4})?$/, 'ZIP Code must be a valid postal code')
    .required('ZIP Code is required'),
  password: yup.string().max(30).min(6, "Password must be at least 6 characters").matches( /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^\\w]).*$/,  "Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character").required("Password is required"),
  confirmPassword: yup.string()
    .oneOf([yup.ref("password")], "Passwords must match!")
    .required(),
});


export const editProviderSchema = yup.object().shape({
  organizationName: yup.string()
  .max(100, 'Organization Name should not exceed 100 characters')
  .required('Organization Name is required'),

  organizationType: yup.string()
  .max(100, 'Organization Type should not exceed 100 characters')
  .required('Organization Type is required'),

  phoneNumber: yup.string().required('Phone Number is required'),
  email: yup.string().email().required(),
  streetAddress: yup.string()
    .max(100, 'Street Address should not exceed 100 characters')
    .required('Street Address is required'),

  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  zipCode: yup.string()
    .matches(/^\d{5}(-\d{4})?$/, 'ZIP Code must be a valid postal code')
    .required('ZIP Code is required'),
});

// export const addDoctorSchema = yup.object().shape({
//   firstName: yup.string().min(1).max(30).required(),
//   lastName: yup.string().min(1).max(30).required(),
//   email: yup.string().email().required(),
//   phoneNumber: yup.string().required(),
//   speciality: yup.array()
//   .of(yup.string().max(100))
//   .min(1, "At least one specialty is required") 
//   .required("At least one specialty is required"),
//   isPrimaryTrue: yup.boolean()
//     .required("Is Primary selection is required")
// });


export const addDoctorSchema = yup.object().shape({
  firstName: yup.string()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters"),
  lastName: yup.string()
    .required("Last Name is required")
    .min(2, "Last Name must be at least 2 characters"),
  email: yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  phoneNumber: yup.string()
    .required("Phone Number is required")
    .matches(PHONE_REGEX, "Invalid phone number format"),
  role: yup.string()
    .required("Role is required")
    .oneOf(["doctor", "staff"], "Invalid role selected"),
});